
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/photo-print-sizes",
      function () {
        return require("private-next-pages/tools/photo-print-sizes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/photo-print-sizes"])
      });
    }
  